import flatten from 'lodash/flatten';

export default {
  computed: {
    selectedFieldsProxy: {
      get() {
        return this.selectedFields;
      },
      set(value) {
        this.$emit('update:selected-fields', value.filter(Boolean));
      },
    },
  },
  methods: {
    isAllFieldsSelected(field, secondLevelObject = false) {
      const fields = this.fieldsToBeToggled(field, secondLevelObject);
      return fields.every(item => this.selectedFieldsProxy.includes(item));
    },
    fieldsToBeToggled(field, secondLevelObject) {
      return secondLevelObject
        ? this.getSecondLevelFieldValues(field)
        : this.getFieldValues(field);
    },
    toggleAll(checked, field, secondLevelObject = false) {
      const fieldsToBeToggled = this.fieldsToBeToggled(field, secondLevelObject);
      const allFields = this.selectedFieldsProxy.concat(fieldsToBeToggled);
      const filteredSelectedFields = this.selectedFieldsProxy.filter(
        item => !fieldsToBeToggled.includes(item),
      );
      this.selectedFieldsProxy = checked ? allFields : filteredSelectedFields;
    },
    getSecondLevelFieldValues(field) {
      const entries = Object.entries(this.fields[field]);
      const fieldObjects = entries.map(item => item[1]);
      const flattenFieldValues = flatten(Object.values(fieldObjects));
      return flattenFieldValues.map(item => item.value);
    },
    getFieldValues(field) {
      return this.fields[field].map(item => item.value);
    },
  },
};
